import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesPreview() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-end justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              探索分类
            </h2>
            <p className="text-sm text-foreground-600">选择您感兴趣的主题，快速找到所需内容</p>
          </div>
          <Link
            to="/categories"
            className="mt-4 md:mt-0 flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部分类 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/categories/${cat.slug}`}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-lg text-accent-600`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}